import React from "react";
import { Modal, Input, InputAdornment, Divider } from "@mui/material";
import { Text } from "../Texts";
import styled from "styled-components";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const ModalCard = (props) => {
  const {
    title,
    open,
    onClose,
    w,
    h,
    Content,
    photo,
    name,
    note,
    review,
    titleActivity,
  } = props;

  return (
    <Modal open={open} onClose={onClose}>
      <Container w={w}>
        <Title>
          <Text>{title}</Text>
          <CloseRoundedIcon onClick={onClose} />
        </Title>
        <ContainerCard>
          <Content
            photo={photo}
            name={name}
            note={note}
            review={review}
            titleActivity={titleActivity}
          />
        </ContainerCard>
      </Container>
    </Modal>
  );
};

export default ModalCard;
const Container = styled.div`
  border: none;
  outline: none;
  display: flex;
  flex-direction: column;
  width: ${(p) => p.w};
  max-width: 90vw;
  height: 65vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  background-color: #ffffff;
  background: #f9f9f9;
  box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12),
    0px 8px 16px -6px rgba(24, 39, 75, 0.08);
  border-radius: 20px;
`;
const ContainerCard = styled.div`
  margin: 0 auto;
  width: 93%;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;
const Title = styled.div`
  display: flex;
  margin: 0;
  padding: 0;
  justify-content: space-between;
  align-items: center;
  height: 20px;
  padding: 25px 0;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 6px -4px rgba(24, 39, 75, 0.12),
    0px 8px 8px -4px rgba(24, 39, 75, 0.08);
  border-radius: 20px 20px 0 0;
  div {
    margin-left: 2rem;
    font-size: 1.2rem;
    font-weight: bold;
  }
  svg {
    margin-right: 2rem;
    cursor: pointer;
    color: #a8a8a8;
  }
`;
